import { useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const defaultBreadcrumbs: BreadcrumbItem[] = [
    { name: '首页', href: '/' },
  ];

  if (location.pathname.startsWith('/category/')) {
    const slug = location.pathname.split('/category/')[1];
    const catNameMap: Record<string, string> = {
      all: '全部', romance: '恋爱', fantasy: '奇幻', action: '动作',
      comedy: '搞笑', thriller: '悬疑', drama: '剧情', horror: '恐怖',
    };
    defaultBreadcrumbs.push({ name: `${catNameMap[slug] || slug}韩漫` });
  } else if (location.pathname.startsWith('/article/')) {
    defaultBreadcrumbs.push({ name: '漫画详情' });
  } else if (location.pathname === '/about') {
    defaultBreadcrumbs.push({ name: '关于我们' });
  }

  const crumbs = items || defaultBreadcrumbs;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': crumbs.map((item, i) => ({
      '@type': 'ListItem',
      'position': i + 1,
      'name': item.name,
      'item': item.href ? `https://www.koreamanhua.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 py-3 flex-wrap">
        {crumbs.map((item, i) => (
          <span key={i} className="flex items-center gap-2">
            {i > 0 && <i className="ri-arrow-right-s-line text-xs"></i>}
            {item.href && i < crumbs.length - 1 ? (
              <a href={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.name}
              </a>
            ) : (
              <span className={i === crumbs.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {item.name}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}